import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RememberService } from '@app/core/services/remember.service';
import { GraphMailService, MailFolderSearchItem } from '@app/modules/microsoft-graph/services/graph-mail.service';
import { EmailGet } from '@app/views/components/email/email.service';

@Component({
    selector: 'tt-email-move-to-folder',
    templateUrl: './email-move-to-folder.component.html',
    styleUrls: ['./email-move-to-folder.component.css'],
})
export class EmailMoveToFolderComponent {
    get: EmailGet;

    moving = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { get: EmailGet },
        private dialogRef: MatDialogRef<EmailMoveToFolderComponent>,
        private remember: RememberService,
        private graphMail: GraphMailService,
    ) {
        this.get = data.get;
    }

    move() {
        this.dialogRef.close(this.get.move_to_folder_id);
    }

    public searchMoveMailFolders = async (): Promise<MailFolderSearchItem[]> => {
        const searchtext = this.get.move_to_folder_name?.trim() ?? '';

        return this.graphMail.searchMailFolders({ userId: this.get.current_mailbox, searchtext });
    };

    onMoveToFolderSelected(item?: MailFolderSearchItem) {
        if (!!this.get) {
            this.get.move_to_folder_id = !!item?.item_id ? '' + item.item_id : '';
            this.get.move_to_folder_name = item?.item_name ?? '';

            this.remember.remember(`w_email.move_to_folder_id.${this.get.current_account_email}.${this.get.current_mailbox}`, this.get.move_to_folder_id);
            this.remember.remember(`w_email.move_to_folder_name.${this.get.current_account_email}.${this.get.current_mailbox}`, this.get.move_to_folder_name);
        }
    }
}
